export default __webpack_public_path__ + "static/media/VitaminD.9c404af8.svg";